import {useLocation} from "react-router";

import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {investmentOfferListConstrains} from "../../investment_offer/constants/investment_offer_list_constraints";
import {getInvestmentOfferListQuery} from "../../investment_offer/utils/get_investment_offer_list_query";
import {getParsedInvestmentOfferListUrl} from "../../investment_offer/utils/get_parsed_investment_offer_list_url";
import {getRequestStateFromRtkQuery} from "../../store/utils/get_request_state_from_rtk_query";
import {ILatestQuery} from "../../utils/latest_query";
import {useGetOfferListQuery} from "../api/get_offer_list";
import {IOfferListOffer} from "../types/IOfferListOffer";
import {OfferType} from "../types/OfferType";

interface IQueryValues extends Omit<ILatestQuery, "sort" | "region" | "type" | "distance" | "is_holiday" | "near_by_offer" | "construction_end_date"> {
    page: number;
    page_size: number;
    sort?: string;
    region?: number | number[];
    type?: OfferType | OfferType[];
    distance?: number;
    is_holiday?: boolean;
    near_by_offer?: number;
    construction_end_date?: number;
}

export function useInvestmentOffers(skipFetch = false, queryValues: IQueryValues): IInfiniteListQuery<IOfferListOffer> {
    const {pathname} = useLocation();

    const investmentOffersUrlParams = getParsedInvestmentOfferListUrl(pathname);
    const investmentQuery = getInvestmentOfferListQuery(investmentOffersUrlParams);

    const {data, isFetching, isLoading, isSuccess, isError, isUninitialized} = useGetOfferListQuery(
        {
            ...queryValues,
            ...investmentOfferListConstrains,
            ...investmentQuery
        },
        {skip: skipFetch}
    );

    return {
        isInitialized: !isUninitialized,
        isSuccess,
        isLoading: isLoading || isFetching,
        isError,
        requestState: getRequestStateFromRtkQuery({isFetching, isLoading, isSuccess, isError}),
        data: data ? data.results : [],
        count: data ? data.count : 0,
        page: data ? data.page : queryValues.page,
        pageSize: data ? data.page_size : queryValues.page_size
    };
}
import {useLocation} from "react-router";

import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {investmentOfferListConstrains} from "../../investment_offer/constants/investment_offer_list_constraints";
import {getInvestmentOfferListQuery} from "../../investment_offer/utils/get_investment_offer_list_query";
import {getParsedInvestmentOfferListUrl} from "../../investment_offer/utils/get_parsed_investment_offer_list_url";
import {getRequestStateFromRtkQuery} from "../../store/utils/get_request_state_from_rtk_query";
import {ILatestQuery} from "../../utils/latest_query";
import {useGetOfferListQuery} from "../api/get_offer_list";
import {IOfferListOffer} from "../types/IOfferListOffer";
import {OfferType} from "../types/OfferType";

interface IQueryValues extends Omit<ILatestQuery, "sort" | "region" | "type" | "distance" | "is_holiday" | "near_by_offer" | "construction_end_date"> {
    page: number;
    page_size: number;
    sort?: string;
    region?: number | number[];
    type?: OfferType | OfferType[];
    distance?: number;
    is_holiday?: boolean;
    near_by_offer?: number;
    construction_end_date?: number;
}

export function useInvestmentOffers(skipFetch = false, queryValues: IQueryValues): IInfiniteListQuery<IOfferListOffer> {
    const {pathname} = useLocation();

    const investmentOffersUrlParams = getParsedInvestmentOfferListUrl(pathname);
    const investmentQuery = getInvestmentOfferListQuery(investmentOffersUrlParams);

    const {data, isFetching, isLoading, isSuccess, isError, isUninitialized} = useGetOfferListQuery(
        {
            ...queryValues,
            ...investmentOfferListConstrains,
            ...investmentQuery
        },
        {skip: skipFetch}
    );

    return {
        isInitialized: !isUninitialized,
        isSuccess,
        isLoading: isLoading || isFetching,
        isError,
        requestState: getRequestStateFromRtkQuery({isFetching, isLoading, isSuccess, isError}),
        data: data ? data.results : [],
        count: data ? data.count : 0,
        page: data ? data.page : queryValues.page,
        pageSize: data ? data.page_size : queryValues.page_size
    };
}
